










import Vue from "vue";
import Component from "vue-class-component";
import { menuItem } from "./interface";
import { menus } from "./data";
@Component
export default class SideBar extends Vue {
  menus = menus;
  active: string | undefined = "/100";
  handleClick(item: menuItem, index: number) {
    if (item.path === this.$route.path) return;
    this.active = item.path;
    this.$router.push(item.path);
  }
  mounted() {
    const { path } = this.$route;
    this.active = this.menus.find(ele => path.indexOf(ele.path) > -1)?.path;
  }
}
